export class ProviderCalendarEvent {

    constructor(){}

    ProviderCalendarEventID: number;
    EventDate: number;
    StartDayMinute: number;
    EndDayMinute: number;
    Description: string;
}